import { AnketaTableOfContents } from './AnketaTableOfContents';

export default AnketaTableOfContents;